const $ = jQuery.noConflict();

$(document).ready(function (){

  //This is what happens when you click the title on mobile or desktop.
  // $('.accordion__title').click(function (){
  //   if ($(this).next('.accordion__content').find('a').attr('tabindex') === -1) {
  //     $(this).next('.accordion__content').find('a').attr('tabindex', '0');
  //   } else if ($(this).next('.accordion__content').find('a').attr('tabindex') === 0) {
  //     $(this).next('.accordion__content').find('a').attr('tabindex', '-1');
  //   } else {}
  //
  //   halfResetAria($);
  //
  // });

  //only reset the expanded attribute
  function halfResetAria ($) {
    if ($('.accordion__title').hasClass('active')) {
      $('.accordion--mobile-only').find('button').attr('aria-expanded', 'true');
    } else {
      $('.accordion--mobile-only').find('button').attr('aria-expanded', 'false');
      $('.accordion__content').removeClass('show-me');

    }
  }

  //full reset of ada controls
  const accordBreakpoint = 767;

  // Remove accordion button functionality on tablet+desktop
  function resetAria ($) {
    if (window.innerWidth <= accordBreakpoint) {
      $('.accordion--mobile-only').find('button').prop('disabled', false);

      halfResetAria($);

    } else if (window.innerWidth > accordBreakpoint) {
      $('.accordion--mobile-only').find('button').attr('aria-expanded', 'true');
      $('.accordion--mobile-only').find('button').prop('disabled', true);
      $('.accordion--mobile-only .accordion__content').find('a').attr('tabindex', '0');
      $('.accordion--mobile-only .accordion__content').addClass('show-me');


    } else {}
  }

  resetAria($);

  $(window).resize(function () {
    setTimeout(function () { resetAria($); }, 100);
  });
  //
  // //Tabbing index set to dropdown arrown for College and Schools page only.
  // if (window.location.href.indexOf('college-and-schools') > -1) {
  //   $('.accordion__title-arrow').attr('tabindex', '0');
  //
  //   document.onkeydown = function (evt) {
  //
  //     let element = document.activeElement;
  //
  //     if ($('.accordion__title-arrow').is(':focus')) {
  //       if (evt.keyCode === 13) {
  //         $(element).parent('.accordion__title').trigger('click');
  //       }
  //     }
  //   };
  // }

});
